import {
  Tag as ChakraTag,
  type TagRootProps,
  type HTMLChakraProps
} from "@chakra-ui/react";

import { forwardRef } from "react";

import { asSlotComponent } from "../internal/v3-slot";

const TagRoot = asSlotComponent(ChakraTag.Root);
const TagLabel = asSlotComponent(ChakraTag.Label);
const TagCloseTrigger = asSlotComponent(ChakraTag.CloseTrigger);

export type TagProps = TagRootProps & {
  onClose?: () => void;
  children?: React.ReactNode;
};

// forwardRef so the root element is exposed when used as a Tooltip `asChild`
// trigger (Ark injects a ref to anchor the positioner).
export const Tag = forwardRef<HTMLDivElement, TagProps>(function Tag(
  { onClose, children, ...props },
  ref
) {
  return (
    <TagRoot ref={ref} {...props}>
      <TagLabel>{children}</TagLabel>
      {onClose ? <TagCloseTrigger onClick={onClose} /> : null}
    </TagRoot>
  );
});

export type { HTMLChakraProps as TagLabelProps };
